import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function QuillEditor({ onChange=null, placeholder="Text", defaultValue=null }) {
    const [text, setText] = useState('');
    const modules = {
        toolbar: [
            [{ 'header': [2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline'],
            [{ 'align': ['', 'right', 'center']}],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'/*, 'image'*/],
            ['clean']
        ],
    };

    useEffect(() => {
        if(defaultValue !== null)
            setText(defaultValue);
    }, [defaultValue]);

    useEffect(() => {
        if(onChange && text){
            onChange(text);
        }
    }, [text, onChange]);

    const handleChange = (value) => {
        setText(value);
    };

    return (
        <ReactQuill modules={ modules } placeholder={ placeholder } value={ text } onChange={ handleChange } />
    )
}
